import style from './index.module.css';
import {Typography} from "@mui/material";

export const Footer = () => {
    return <div className={style.root}>
        <Typography color={'primary'}><b>This tool is for internal reference only and is not for external presentation.</b></Typography>
    </div>
}
